// src/Pages/Landing/JoyrideKymenlaaksoLanding.jsx
import React from "react";
import JoyrideMaakuntaLanding from "./JoyrideMaakuntaLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideKymenlaaksoLanding() {
  return (
    <JoyrideMaakuntaLanding
      maakunta="Kymenlaakso"
      cities={[
        "Kouvola",
        "Kotka",
        "Hamina",
        "Iitti",
        "Pyhtää",
        "Miehikkälä",
        "Virolahti"
      ]}
      regionText="Bilebändi Joyride tekee keikkoja myös Kymenlaakson alueelle tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Kouvolan, Kotkan ja Haminan seutu sopivat hyvin esimerkiksi häihin, yritysjuhliin, kesäjuhliin ja pikkujouluihin, kun juhliin halutaan energinen livebändi."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}